<!--
 * @Author: 李鸿润
 * @Date: 2021-07-22 08:42:54
 * @LastEditTime: 2021-07-29 19:27:28
 * @LastEditors: Please set LastEditors
 * @Description: 后勤管理边界
 * @FilePath: \hpss-ui\src\views\crmedical\value\valuedeclare\logisticsManagementBoundary.vue
-->
<template>
    <div id="logistics">
        <h2>后勤管理边界重新规划</h2>
        <el-row class="title">
            <el-col :span="6">一级分类</el-col>
            <el-col :span="6">二级分类</el-col>
            <el-col :span="12">具体分类</el-col>
        </el-row>
        <el-row class="title">
            <el-col :span="12" >
              <el-form :model="contentValue" :rules="contentValueRules" ref='contentValueRef'>
                <div class="logisticsArea" v-for="(item,index) in secondLevelMenu" :key="index">   
                     <el-col :span="10">
                         <el-input :value="getPrimary(item.parentId)" disabled></el-input>
                     </el-col>
                     <el-col :span="2"></el-col>
                     <el-col :span="10">
                          <el-input :value='item.dictValue' disabled></el-input>
                     </el-col>
                     <div class="contentArea">
                       <el-form-item
                        :prop="'value'+index"
                        label=""  
                    >
                            <el-select
                                v-model="contentValue['value'+index]"
                                size="medium"
                                multiple
                                filterable
                                placeholder="请选择文章标签"
                                @change="change"
                                >
                                <el-option
                                v-for="item in selectValues['value'+index]"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                            </el-form-item>
                      </div>
                      
                </div>
              </el-form>
               
            </el-col>
           
        </el-row>
    </div>    
</template>

<script>
import {
  getMangementContent,
  getMangementSelect,
  saveValueMangement,
  getBoundaryManagement,
  getBoundaryTypeName
} from '@/api/crmedical/value/valuebudget';
import { getDictionary } from '@/api/common';
import { async } from 'q';
//获取价值边界
import { getChildList } from '@/api/system/dict.js'
export default {
  props: {
    editDetailInfo: {},
  },
  data() {
    return {
      refList: ['contentValueRef'],
      validateFlag: false,
      form: {},
      contentValueRules: {
        // value0: [{ required: true, message: '必填', trigger: 'change' }],
        // value1: [{ required: true, message: '必填', trigger: 'change' }],
        // value2: [{ required: true, message: '必填', trigger: 'change' }],
        // value3: [{ required: true, message: '必填', trigger: 'change' }],
        // value4: [{ required: true, message: '必填', trigger: 'change' }],
        // value5: [{ required: true, message: '必填', trigger: 'change' }],
      },
      contentValue: {
       
      },
      selectValues: {
       
      },
      //一级菜单id
      primaryMenuID:[],
      primaryMenuDictionary:[],
      secondLevelMenu:[]
    };
  },
  methods: {
    getPrimary(id){
      let lable
       this.primaryMenuDictionary.forEach(item=>{
        if(item.id == id){
          lable = item.dictValue
        }
      })
      return lable
    },
    change(e) {
      console.log(e);
      console.log(this.contentValue.value1);
    },
    async initData() {
      //一级菜单字典
          getBoundaryTypeName().then(({data})=>{
            this.primaryMenuDictionary = data
          })
      //获取二级菜单的所有数据
     await getBoundaryManagement().then((data)=>{
        this.secondLevelMenu = data.data
        this.secondLevelMenu.forEach(async(item,index)=>{
          this.contentValueRules['value'+index] =[{ required: true, message: '必填', trigger: 'change' }]
          await getMangementSelect(item.dictKey).then(({ data }) => {
            this.selectValues['value'+index] = data;
           this.$forceUpdate()
          });
          if(true){
             // 回显数据
              getMangementContent(item.dictKey, this.editDetailInfo.id).then( ({ data }) => {
              let arry = [];
              if (data.length > 0) {
                data.forEach((ele) => {
                  arry.push(ele.id);
                });
              }
              this.contentValue['value'+index] = arry;
            });
          }
        })
        console.log("下拉",this.selectValues)
      })

    },
    //（保存）提交
   async submit() {
      console.log('content', this.contentValue);
      let ids = '';
      for (const key in this.contentValue) {
        ids += this.contentValue[key].join(',');
        ids += ',';
      }
      let budgetId = this.editDetailInfo.id;
      this.refList.forEach((item) => {
        this.$refs[item].validate((valid) => {
          if (valid) {
            this.validateFlag = true;
          } else {
            this.validateFlag = false;  
          }
        });
      });
        if(this.validateFlag){
         await   saveValueMangement({ids:ids,budgetId:budgetId}).then(({ code }) => {
              if (code == 200) {
                this.$message({
                  showClose: true,
                  message: '数据保存成功',
                  type: 'success',
                });
                this.validateFlag = true;
              } else {
                this.validateFlag = false;
              }
            });
        }else{
             this.$message({
              showClose: true,
              message: '请将数据填写完整',
              type: 'error',
            });
        }
      return this.validateFlag;
    },
  },
  created() {
    this.initData();
  },
};
</script>
<style scoped>
.title {
  margin: 20px 76px;
}
.logisticsArea {
  padding-bottom: 90px;
  width: 100%;
}
.contentArea {
  padding-bottom: 0;
  display: grid;
  padding-left: 31px
}
.contentArea::after {
  display: block;
  content: '';
  height: 10px;
  clear: both;
}
</style>
<style>
#logistics .el-input--medium {
  width: 600px;
}
#logistics .el-form-item__error {
  top: 31px;
}
</style>

